import React from 'react';
import classnames from 'classnames';

import { Link } from 'gatsby';

import * as S from './TextComponent.module.css';
import * as T from './TextComponent.types';

const Text: React.FunctionComponent<T.ITextProp> = ({
  children,
  bold,
  color,
  underline,
}) => {
  const style: React.CSSProperties = {
    color: color || 'inherit',
    borderBottom: underline && `1px solid ${color || ''}`,
  };

  if (bold) {
    return <b style={style}>{children}</b>;
  }

  return <a style={style}>{children}</a>;
};

export const TextComponent: React.FunctionComponent<T.ITextComponentProps> = ({
  content,
  className,
}) => {
  const renderText = (item: T.ITextType, index: number) => {
    if (typeof item === 'string') {
      return item;
    }

    switch (item.type) {
      case 'text':
        return (
          <Text key={index} bold={item.bold}>
            {item.text}
          </Text>
        );
      case 'link':
        return (
          <Link key={index} to={item.link} target={item.target}>
            <Text bold={item.bold} color={item.color} underline>
              {item.text}
            </Text>
          </Link>
        );
      case 'break':
        return <br key={index} />;
      case 'spacer':
        return <div key={index} className={S.spacer} />;
      default:
        return;
    }
  };

  return (
    <div className={classnames(S.content, className)}>
      {content.map((item: T.ITextType | T.IBlock, index: number) => {
        if (item instanceof Object && item.type === 'block') {
          return (
            <div
              key={index}
              style={
                item.bgColor && {
                  margin: '0 -16px',
                  padding: 16,
                  backgroundColor: item.bgColor,
                }
              }
              className={item.className}
            >
              {item.content.map(renderText)}
            </div>
          );
        }

        return renderText(item, index);
      })}
    </div>
  );
};
